{
  "brand": "BidNova Auctions",
  "browse": "Browse",
  "trends": "Trends",
  "community": "Community",
  "watchlist": "Watchlist",
  "wantList": "Want List",
  "myBids": "My Bids",
  "orders": "Orders",
  "sell": "Sell",
  "signIn": "Sign in",
  "join": "Join",
  "signOut": "Sign out",
  "account": "Account",
  "accountMenu": "Account menu for {name}",
  "dashboard": "Dashboard",
  "accountProfile": "Account & Profile",
  "sellerDashboard": "Seller Dashboard",
  "myAuctions": "My Auctions",
  "orderCentre": "Order Centre",
  "collection": "Collection",
  "notifications": "Notifications",
  "admin": "Admin",
  "language": "Language",
  "changeLanguage": "Change language",
  "footer": {
    "tagline": "The UK's auction marketplace for trading cards, collectibles, fashion and more. Live auctions in GBP, protected end-to-end by Stripe and a fully UK GDPR-compliant platform.",
    "marketplace": "Marketplace",
    "browseAuctions": "Browse auctions",
    "marketTrends": "Market trends",
    "sellCard": "Sell a card",
    "community": "Community",
    "communityHub": "Community Hub",
    "articles": "News & Articles",
    "events": "UK Card Shows",
    "dealers": "Dealer Directory",
    "categories": "Popular Categories",
    "legal": "Legal",
    "terms": "Terms & Conditions",
    "privacy": "Privacy",
    "cookies": "Cookies",
    "buyerTerms": "Buyer Terms",
    "sellerAgreement": "Seller Agreement",
    "refunds": "Refunds & Disputes",
    "cookieSettings": "Cookie settings",
    "contact": "Contact",
    "registered": "Registered in England & Wales",
    "trusted": "Trusted & Secure",
    "stripeSecured": "Stripe Secured",
    "gdpr": "GDPR",
    "cards": "Card & Apple Pay",
    "rights": "© 2026 BidNova Auctions. All rights reserved.",
    "governed": "Governed by the laws of England & Wales · Prices in GBP (£)"
  },
  "home": "Home",
  "tradingCards": "Trading Cards",
  "collectibles": "Collectibles",
  "fashion": "Fashion",
  "sealedProducts": "Sealed Products",
  "accessories": "Accessories",
  "sellAnItem": "Sell an Item",
  "searchPlaceholder": "Search cards, figures, clothing and more…"
}
